import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ToolService from '@/providers/tools';

@Component({
  name: 'ed-file-loader'
})
export default class EdFileLoaderComponent extends Vue {

  @Prop() readonly progress: number;
  @Prop() readonly label: string;
  @Prop() readonly downloadAmount: number;
  @Prop() readonly downloadTotalSize: number;
  @Prop() readonly downloadSpeed: number;
  @Prop() readonly isFileInCache: number;
  @Prop() readonly filename: string;

  get loadInfo(){
    return ToolService.exitSpecialChars(this.$i18n.t('common.loadingFromFileSystem', {filename: this.filename}));
  }

  get downloadInfo(){
    return ToolService.exitSpecialChars(this.$i18n.t('common.loadingFromServerInfo', {filename: this.filename}));
  }

  get downloadProgressInfo(){
    return this.$i18n.t('common.loadingFromServerProgressInfo', {progress: this.progress, downloadAmount: this.downloadAmount.toFixed(1), 
        downloadTotalSize: this.downloadTotalSize.toFixed(1), downloadSpeed: this.downloadSpeed });
  }
}